export enum KEYS {
  GlobeComponent = '@/stellar-globe-components/GlobeComponent',
  TileLayerComponent = '@/stellar-globe-components/TileLayerComponent',
}
